import React from 'react';

export default function Logo({ size = 26, withText = true, className = '' }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="logo">
        <defs>
          <linearGradient id="lg1" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
            <stop stopColor="#ff3ea5" />
            <stop offset="0.5" stopColor="#ff8a3d" />
            <stop offset="1" stopColor="#ffd23d" />
          </linearGradient>
        </defs>
        <circle cx="16" cy="16" r="15" stroke="url(#lg1)" strokeWidth="2" />
        <path d="M10 11c2 3 4 5 6 5s4-2 6-5" stroke="url(#lg1)" strokeWidth="2.2" strokeLinecap="round" fill="none" />
        <path d="M10 21c2-3 4-5 6-5s4 2 6 5" stroke="url(#lg1)" strokeWidth="2.2" strokeLinecap="round" fill="none" />
      </svg>
      {withText && <span className="font-display font-extrabold text-xl tracking-tight">Flowly</span>}
    </div>
  );
}
